import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col } from "reactstrap";
import QwikForm from "components/form/QwikForm";
import QwikInput from "components/form/QwikInput";
import { useUpdateEarningMutation } from "store/features/earning/earningManagementApi";
import { toast } from "sonner";

const EditEarningModal = ({ isOpen, toggle, earning, onEarningUpdate }) => {
  const [updateEarning, { isLoading }] = useUpdateEarningMutation();

  const handleSubmit = async (data) => {
    try {
      await updateEarning({ id: earning.id, ...data }).unwrap();
      toast.success("Earning updated successfully");
      onEarningUpdate();
    } catch (error) {
      toast.error("Failed to update earning");
      console.error('Earning update error:', error);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Edit Earning</ModalHeader>
      <QwikForm onSubmit={handleSubmit} defaultValues={earning}>
        <ModalBody>
          <Row>
            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="project_name"
                  label="Project Name"
                  placeholder="Enter project name"
                  type="text"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="client_name"
                  label="Client Name"
                  placeholder="Enter client name"
                  type="text"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="amount"
                  label="Amount"
                  placeholder="Enter amount"
                  type="number"
                  step="0.01"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="notes"
                  label="Notes"
                  placeholder="Enter any notes about this earning"
                  type="textarea"
                  className="form-control"
                  rows="3"
                />
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="light" onClick={toggle}>
            Cancel
          </Button>
          <Button type="submit" color="primary" disabled={isLoading}>
            {isLoading ? "Updating..." : "Update Earning"}
          </Button>
        </ModalFooter>
      </QwikForm>
    </Modal>
  );
};

export default EditEarningModal;